import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import ProfilePage from './pages/ProfilePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsAndConditionsPage from './pages/TermsAndConditionsPage';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar 
          logoText="Muse Legal Group"
          ctaText="Free Consultation"
          ctaHref="/contact"
          navLinks={[
            { text: "Home", href: "/" },
            { text: "Practice Areas", href: "/#practice" },
            { text: "About", href: "/#about" },
            { text: "Testimonials", href: "/#testimonials" },
            { text: "Contact", href: "/contact" }
          ]}
        />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

